module.exports = __webpack_public_path__ + "img/geology-venus.061d1994.png";